import React from "react"
import { Link } from "gatsby"
import Section from "../../../../core/layout/main/section/Section"
import * as RhJobSectorMosaic from "./RhJobSectorMosaicSection.module.scss"
import { sectorUrl } from "../../../../../utils/routeLib"
import Image from "../../../common/blocks/image/Image"
const RhJobSectorMosaicSection = ({ Title, Text, SecteurActivities }) => {
  return (
    <>
      <Section
        className="pbl-6 pin-0"
        container="xxlarge"
      >
        <div
          className={`text-center pin-6 pb-3 loadin ${RhJobSectorMosaic.Text}`}
        >
          <h2>{Title}</h2>
          <p>{Text}</p>
        </div>
        <div className={`${RhJobSectorMosaic.grid} loadin`}>
          {SecteurActivities.data.map((image, i) => (
            <div
              key={i}
              className={`${RhJobSectorMosaic.imageContainer}`}
            >
              <Image
                dataSizesPreset="hero"
                imgSrc={image.attributes.mosaicImage.data[0]?.attributes.url}
                imgAlt={image.attributes.mosaicImage.data[0]?.attributes.alternativeText}
                imgWidth={image.attributes.mosaicImage.data[0]?.attributes.width}
                imgHeight={image.attributes.mosaicImage.data[0]?.attributes.height}
                formats={image.attributes.mosaicImage.data[0]?.attributes?.formats}
                className={RhJobSectorMosaic.image}
                loading="lazy"
              />
              <span className={RhJobSectorMosaic.Lien}>
                <Link to={sectorUrl(image.attributes.slug)}>
                  {image.attributes.name}
                </Link>
              </span>
            </div>
          ))}
        </div>
      </Section>
    </>
  )
}
export const name = "RhJobSectorMosaic"

export const init = (componentData) => {
  return (
    <RhJobSectorMosaicSection
      key={componentData.id}
      Title={componentData.Titre}
      Text={componentData.Text}
      Images={componentData.Images}
      SecteurActivities={componentData.secteur_activites}
    />
  )
}

export default RhJobSectorMosaicSection
